/* eslint-disable no-useless-escape */
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import FileScanState from '../common/file-scan-state/FileScanState';
import { useTranslation } from 'react-i18next';

import './ProactiveDlp.scss';
import ScoreContainer from '../common/score-container/ScoreContainer';
import ScoreReportView from '../common/score-report-view/ScoreReportView';
import ScoreMoreDetail from '../common/score-more-detail/ScoreMoreDetail';

const ProactiveDlp = ({ showResult, score, result, resultLevel, viewReportClick, isFileTypeSupported, invalidFileImg, availableFileImg }) => {
    const { t, ready } = useTranslation();

    const scoreDOM = useMemo(() => {
        if (showResult) {
            return <ScoreContainer label={t('Result:')} score={score} levelText={result} infoText={t('Items with critical information')} level={resultLevel}/>;
        }
        return <FileScanState isFileTypeSupported={isFileTypeSupported} scanOption={t('Proactive DLP')} invalidFileImg={invalidFileImg} availableFileImg={availableFileImg}/>;
    }, [showResult, isFileTypeSupported, score, result, resultLevel, invalidFileImg, availableFileImg]);

    const infoDOM = useMemo(() => {
        if (showResult) {
            return <ScoreReportView
                onViewClick={viewReportClick}
                buttonContent={t('View PII Report')}
                reportText={t('OPSWAT Proactive Data Loss Prevention can help prevent potential data breaches and regulatory compliance violations by detecting and blocking sensitive data')}>
            </ScoreReportView>;
        }
        return <ScoreMoreDetail
            detailLink={t('<a href=\"https://www.opswat.com/technologies/proactive-data-loss-prevention\" rel=\"noopener noreferrer\" target=\"_blank\">Learn more about Proactive DLP</a>')}
            detailText={t('OPSWAT Proactive Data Loss Prevention can help prevent potential data breaches and regulatory compliance violations by detecting and blocking sensitive data')}>
        </ScoreMoreDetail>;
    }, [showResult]);

    if (!ready) {
        return null;
    }

    return <div className='proactiveDlp'>
        <Row>
            <Col md={6}>
                <p className='h6Mask'>{t('Proactive DLP')}</p>
                {scoreDOM}
            </Col>
            <Col md={6}>
                {infoDOM}
            </Col>
        </Row>

    </div>;
};

ProactiveDlp.propTypes = {
    showResult: PropTypes.bool.isRequired,
    score: PropTypes.number,
    result: PropTypes.string,
    resultLevel: PropTypes.string,
    viewReportClick: PropTypes.func,
    isFileTypeSupported: (props, propName) => {
        const isFileTypeSupported = props[propName];
        const showResult = props['showResult'];

        if ((isFileTypeSupported !== true && isFileTypeSupported !== false) && !showResult) {
            return new Error(`Proptype ${propName} should be defined when 'showResult' is false`);
        }

        if (isFileTypeSupported && typeof isFileTypeSupported !== 'boolean') {
            return new Error(`The '${propName}' is required to be of type boolean`);
        }
    },
    invalidFileImg: PropTypes.object,
    availableFileImg: PropTypes.object
};

export default ProactiveDlp;
